module.exports = __webpack_public_path__ + "public/img/fire.7a5d25a6.png";